var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_8754417",
    clipPath: "url(#clip0_489_9075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9899 29.6946C11.5365 29.6946 6.28516 24.4433 6.28516 17.9899C6.28516 11.5365 11.5365 6.28516 17.9899 6.28516C24.4433 6.28516 29.6946 11.5365 29.6946 17.9899C29.6946 24.4433 24.4433 29.6946 17.9899 29.6946Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9897 4.51318C17.6945 4.51318 17.4414 4.2812 17.4414 3.96485V0.54833C17.4414 0.253076 17.6945 0 17.9897 0C18.3061 0 18.5381 0.253076 18.5381 0.54833V3.96485C18.5381 4.2812 18.3061 4.51318 17.9897 4.51318Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.012 6.38985C24.9066 6.38985 24.8222 6.36876 24.7379 6.32658C24.4637 6.17895 24.3793 5.84152 24.527 5.58845L26.2563 2.61481C26.4039 2.34064 26.7414 2.25628 26.9944 2.40391C27.2475 2.55154 27.353 2.88897 27.1843 3.16314L25.476 6.11569C25.3705 6.30549 25.2018 6.38985 25.012 6.38985Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1362 11.5362C29.9464 11.5362 29.7566 11.4307 29.6723 11.262C29.5246 10.9879 29.609 10.6715 29.8621 10.5028L32.8357 8.79454C33.0888 8.64691 33.4262 8.73127 33.5738 9.00543C33.7215 9.25851 33.6371 9.59594 33.384 9.74357L30.4104 11.4518C30.326 11.5151 30.2417 11.5362 30.1362 11.5362Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4508 18.5381H32.0132C31.7179 18.5381 31.4648 18.3061 31.4648 17.9897C31.4648 17.6945 31.7179 17.4414 32.0132 17.4414H35.4508C35.746 17.4414 35.9991 17.6945 35.9991 17.9897C35.9991 18.3061 35.746 18.5381 35.4508 18.5381Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1099 27.2686C33.0044 27.2686 32.9201 27.2475 32.8357 27.1843L29.8621 25.476C29.609 25.3284 29.5246 24.9909 29.6723 24.7379C29.8199 24.4637 30.1573 24.3793 30.4104 24.527L33.384 26.2563C33.6371 26.4039 33.7215 26.7414 33.5738 26.9944C33.4895 27.1632 33.2997 27.2686 33.1099 27.2686Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7203 33.6592C26.5305 33.6592 26.3407 33.5537 26.2563 33.385L24.527 30.4114C24.3793 30.1583 24.4637 29.8209 24.7379 29.6732C24.9909 29.5256 25.3284 29.61 25.476 29.863L27.1843 32.8367C27.353 33.0897 27.2475 33.4272 26.9944 33.5748C26.9101 33.6381 26.8046 33.6592 26.7203 33.6592Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9897 36.0001C17.6945 36.0001 17.4414 35.747 17.4414 35.4518V32.0142C17.4414 31.7189 17.6945 31.4658 17.9897 31.4658C18.3061 31.4658 18.5381 31.7189 18.5381 32.0142V35.4518C18.5381 35.747 18.3061 36.0001 17.9897 36.0001Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2796 33.6588C9.17415 33.6588 9.08979 33.6377 9.00543 33.5744C8.73127 33.4268 8.64691 33.0894 8.79454 32.8363L10.5028 29.8626C10.6715 29.6096 10.9879 29.5041 11.262 29.6728C11.5151 29.8205 11.5995 30.1579 11.4518 30.411L9.74357 33.3846C9.63812 33.5533 9.4694 33.6588 9.2796 33.6588Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88897 27.2686C2.69917 27.2686 2.50936 27.1632 2.40391 26.9944C2.25628 26.7414 2.34064 26.4039 2.61481 26.2563L5.58845 24.527C5.84152 24.3793 6.17895 24.4637 6.32658 24.7379C6.47421 24.9909 6.38985 25.3284 6.13678 25.476L3.16314 27.1843C3.07878 27.2475 2.97333 27.2686 2.88897 27.2686Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96485 18.5381H0.54833C0.253076 18.5381 0 18.3061 0 17.9897C0 17.6945 0.253076 17.4414 0.54833 17.4414H3.96485C4.2812 17.4414 4.51318 17.6945 4.51318 17.9897C4.51318 18.3061 4.2812 18.5381 3.96485 18.5381Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86261 11.5362C5.75716 11.5362 5.6728 11.5151 5.58845 11.4518L2.61481 9.74357C2.34064 9.59594 2.25628 9.25851 2.40391 9.00543C2.55154 8.73127 2.88897 8.64691 3.16314 8.79454L6.13678 10.5028C6.38985 10.6715 6.47421 10.9879 6.32658 11.262C6.22113 11.4307 6.03133 11.5362 5.86261 11.5362Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9879 6.38985C10.7981 6.38985 10.6082 6.30549 10.5028 6.13678L8.79454 3.16314C8.64691 2.88897 8.73127 2.55154 9.00543 2.40391C9.25851 2.25628 9.59594 2.34064 9.74357 2.61481L11.4518 5.58845C11.5995 5.84152 11.5151 6.17895 11.262 6.32658C11.1777 6.36876 11.0722 6.38985 10.9879 6.38985Z",
    fill: "#FF9D05"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9549 24.6326C21.8917 24.6326 21.8284 24.6326 21.7651 24.5904L17.9901 23.1352L14.2361 24.5904C14.0674 24.6747 13.8565 24.6326 13.7089 24.5271C13.5613 24.4217 13.4769 24.253 13.498 24.0631L13.73 20.035L11.1571 16.9138C11.0516 16.7661 11.0094 16.5763 11.0727 16.3865C11.136 16.2178 11.2625 16.0702 11.4523 16.028L15.3539 15.0157L17.5472 11.5992C17.6316 11.4515 17.8214 11.3672 17.9901 11.3672C18.1799 11.3672 18.3486 11.4515 18.4541 11.5992L20.6474 15.0157L24.549 16.028C24.7177 16.0702 24.8653 16.2178 24.9286 16.3865C24.9918 16.5763 24.9497 16.7661 24.8231 16.9138L22.2713 20.035L22.5033 24.0631C22.5033 24.253 22.4189 24.4217 22.2713 24.5271C22.1869 24.6115 22.0604 24.6326 21.9549 24.6326Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_489_9075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardStar);
export default __webpack_public_path__ + "static/media/reward-star.0948dea62cf34e0f4799c47967133000.svg";
export { ForwardRef as ReactComponent };